// extracted by mini-css-extract-plugin
export default {"container":"ScreenInfo_container__rZ0I7","icon":"ScreenInfo_icon__H5YKL","title":"ScreenInfo_title__L4D42"};